module.exports = __webpack_public_path__ + "static/media/in_a_week_10.74ef0da9.jpg";